{
  "Clear search": "Suche löschen"
}
